import { GenericService } from '@/service/GenericService.ts';
import { DataTransferJobRepository } from '@/repository/DataTransferJobRepository.ts';
import { DataTransferStage } from '@/API.ts';
import log from 'loglevel';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';

export class DataTransferJobService extends GenericService<DataTransferStage> {
  protected repository: DataTransferJobRepository;

  constructor(dataTransferJobRepository: DataTransferJobRepository) {
    super(dataTransferJobRepository);
    this.repository = dataTransferJobRepository;
  }

  async list(options?: GraphQLOptionsV6['variables']) {
    try {
      return await this.repository.list(options);
    } catch (error) {
      log.error('Error listing:', error);
      throw error;
    }
  }
}
